// utils/hostTheme.js
// ------------------
// Which skin the widget wears is the host's decision, passed as `theme` at init
// (see public/chatwidget.js). Only iDoks passes it, and only while its workspace is
// on the redesign — the knowledge base and the custom bots pass nothing, so nothing
// gated on this can reach them.
//
// This reads the query string rather than the `idoks-new-theme` class, because the
// class is added by an effect: reading the param gives the same answer on the very
// first render, so nothing has to flash the old look before the new one lands.

export const isIdoksNewTheme = () =>
  new URLSearchParams(window.location.search).get('theme') === 'idoks-new';

export default isIdoksNewTheme;
